import { lazy } from "react";

// project imports
import GuestGuard from "utils/route-guard/GuestGuard";
import MinimalLayout from "layout/MinimalLayout";
import NavMotion from "layout/NavMotion";
import Loadable from "ui-component/Loadable";
import OtpConfirmation from "views/pages/authentication/authentication3/OtpConfirmation";

// login routing
const AuthLogin = Loadable(lazy(() => import("views/pages/authentication/authentication3/Login3")));
const AuthRegister = Loadable(
  lazy(() => import("views/pages/authentication/authentication3/Register3"))
);
const AuthForgotPassword = Loadable(
  lazy(() => import("views/pages/authentication/authentication3/ForgotPassword3"))
);
const SuccessPage = Loadable(lazy(() => import("views/pages/SuccessPage")));
// ==============================|| AUTH ROUTING ||============================== //

const LoginRoutes = {
  path: "/",
  element: (
    <NavMotion>
      <GuestGuard>
        <MinimalLayout />
      </GuestGuard>
    </NavMotion>
  ),
  children: [
    {
      path: "/login",
      element: <AuthLogin />,
    },
    {
      path: "/otp-confirmation",
      element: <OtpConfirmation />,
    },
    {
      path: "/register",
      element: <AuthRegister />,
    },
    {
      path: "/forgot",
      element: <AuthForgotPassword />,
    },
    {
      path: "/success",
      element: <SuccessPage />,
    },
  ],
};

export default LoginRoutes;
